import { makeAutoObservable } from "mobx";

import { setDataToStorage, getDataFromStorage, removeFromStorage } from "@/utils/app";

import type { User } from "@/types/User.ts";

class AuthStore {
  isAuthenticated = false;
  token: string | null;
  user: User;
  tokenStorage: string = "auth";
  isLoading: boolean = true;

  constructor() {
    makeAutoObservable(this);
    this.hydrate();
  }

  hydrate() {
    this.token = getDataFromStorage(this.tokenStorage);

    if (this.token) {
      this.isAuthenticated = true;
    }

    this.isLoading = false;
  }

  setToken(token: string) {
    this.token = token;
    setDataToStorage(this.tokenStorage, token);
  }

  setUser(user: User) {
    this.user = user;
  }

  logout() {
    this.token = null;
    this.user = null;
    removeFromStorage(this.tokenStorage);
  }

  get getToken() {
    return this.token

    const token = this.token ? { Authorization: `Bearer ${this.token}` } : null;

    return {
      Authorization: this.token || null,
    };
  }
}

export const authStore = new AuthStore();
